var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{key:_vm.currency},[_vm._v(_vm._s(_vm.output))])}
var staticRenderFns = []

export { render, staticRenderFns }